<template>
    <div class="w-full">
        <input v-if="typeof $attrs.multiple !== 'undefined' && $attrs.multiple && typeof inputValue == 'object'" type="hidden" :id="$attrs.id + '_value'"
            :name="$attrs.id" :value="JSON.stringify(inputValue.map(a => a.id ?? a))">
        <input v-else-if="inputValue && typeof inputValue === 'object' && 'id' in inputValue" type="hidden" :id="$attrs.id + '_value'" :name="$attrs.id" v-model="inputValue.id">
        <input v-else-if="inputValue && typeof inputValue === 'object' && $attrs.value_by in inputValue" type="hidden" :id="$attrs.id + '_value'" :name="$attrs.id" v-model="inputValue[$attrs.value_by]">
        <input v-else-if="inputValue" type="hidden" :id="$attrs.id + '_value'" :name="$attrs.id" v-model="inputValue">
        <multiselect :label="$attrs.label" :track-by="$attrs.label" v-model="inputValue" :options="$attrs.options" class="leading-5 h-full"
            :close-on-select="$attrs.closeOnSelect" @select="valueSelected"
            :multiple="typeof $attrs.multiple !== 'undefined' ? $attrs.multiple : false">            
            <template slot="singleLabel" slot-scope="{ option }" class="h-full">
                <img v-if="$attrs.show_ico && option['ico']" :src="option['ico']" class="max-h-6 max-w-10">
                <strong v-else class="leading-5">
                    {{ Array.isArray(option) && option[$attrs.label] ? option[$attrs.label] : typeof option === 'object' && option.hasOwnProperty($attrs.label) ? option[$attrs.label]  : option  }}
                </strong>
            </template>
        </multiselect>
    </div>
</template>
  
<script>
import Multiselect from 'vue-multiselect'
export default {
    components: {
        Multiselect,
    },
    data() {
        return {
            inputValue: '',
            forceUpdate: 0,
        };
    },
    methods: {
        valueSelected(value, e) {
            this.$emit('changed-value', value)
        }
    },
    created() {
        if (typeof this.$attrs.multiple !== 'undefined' && this.$attrs.multiple) {
            this.inputValue = this.$attrs.value;
        } else {
            const found = this.$attrs.options.find((element) => {
                return element.id == this.$attrs.value || element == this.$attrs.value || element[this.$attrs.label] == this.$attrs.value || (element.name != undefined && element.name == this.$attrs.value.name)
            });
            if (found) {
                this.inputValue = found;
            }
        }
    }
};
</script>